





























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import * as api from '@/api/api';
import * as def from '@/common/definitions';
import ArrayUtil from '@/models/common/arrayutil';
import Enumerable from 'linq';

class CountryPolicyListItem {
  public get requestedPoint(): number {
    if (this.data && this.data.status === api.CountryPolicy.statusBoosted) {
      return this.type.point / 2;
    }
    return this.type.point;
  }

  public get isBoosted(): boolean {
    if (this.data) {
      return this.data.status === api.CountryPolicy.statusBoosted;
    }
    return false;
  }

  public constructor(public type: def.CountryPolicyType,
                     public data?: api.CountryPolicy) {}
}

@Component({
  components: {
    CharacterIcon,
  },
})
export default class CountryPolicyList extends Vue {
  @Prop() public country!: api.Country;
  @Prop() public policies!: api.CountryPolicy[];
  public category: number = 0;
  public availablePolicies: CountryPolicyListItem[] = [];
  public selectablePolicies: CountryPolicyListItem[] = [];
  public afterPolicies: CountryPolicyListItem[] = [];
  public currentAvailablePolicies: CountryPolicyListItem[] = [];
  public currentSelectablePolicies: CountryPolicyListItem[] = [];
  public currentAfterPolicies: CountryPolicyListItem[] = [];
  @Prop({
    default: false,
  }) public canEdit!: boolean;
  @Prop({
    default: () => new def.CountryPolicyType(-1),
  }) public value!: def.CountryPolicyType;
  @Prop({
    default: false,
  }) public isMyCountry!: boolean;

  @Watch('policies')
  public onTypesChanged() {
    const policiesAvailable = this.policies.filter((p) => p.status === api.CountryPolicy.statusAvailable ||
                                                          p.status === api.CountryPolicy.statusAvailabling);
    const policiesNotAvailable = this.policies.filter((p) => p.status !== api.CountryPolicy.statusAvailable);

    this.availablePolicies = Enumerable.from(def.COUNTRY_POLICY_TYPES)
      .join(policiesAvailable, (p) => p.id, (p) => p.type, (pt, pd) => new CountryPolicyListItem(pt, pd))
      .toArray();
    this.selectablePolicies = Enumerable.from(def.COUNTRY_POLICY_TYPES)
      .where((p) => !policiesAvailable.some((pp) => pp.type === p.id) && p.canGet)
      .where((p) => !p.subjectAppear || p.subjectAppear(policiesAvailable))
      .groupJoin(policiesNotAvailable,
        (p) => p.id, (p) => p.type, (p, ps) => new CountryPolicyListItem(p, ps.firstOrDefault()))
      .toArray();
    this.afterPolicies = Enumerable.from(def.COUNTRY_POLICY_TYPES)
      .where((p) => (p.subjectAppear ? !p.subjectAppear(policiesAvailable) : false) && p.canGet)
      .groupJoin(policiesNotAvailable,
        (p) => p.id, (p) => p.type, (p, ps) => new CountryPolicyListItem(p, ps.firstOrDefault()))
      .toArray();

    this.currentAvailablePolicies = this.availablePolicies;
    this.currentSelectablePolicies = this.selectablePolicies;
    this.currentAfterPolicies = this.afterPolicies;

    this.onCategoryChanged();
  }

  @Watch('category')
  public onCategoryChanged() {
    this.currentAvailablePolicies = this.availablePolicies.filter((p) => p.type.category === this.category);
    this.currentSelectablePolicies = this.selectablePolicies.filter((p) => p.type.category === this.category);
    this.currentAfterPolicies = this.afterPolicies.filter((p) => p.type.category === this.category);
  }

  private getPolicyLimit(policy: CountryPolicyListItem): api.GameDateTime {
    if (policy.data && policy.data.status === api.CountryPolicy.statusAvailabling) {
      return api.GameDateTime.fromNumber(
        api.GameDateTime.toNumber(policy.data.gameDate) + policy.type.availableDuring);
    }
    return new api.GameDateTime();
  }
}
